import { useEffect } from 'react';

import { medirVisita } from '@/lib/medir';

/**
 * Cuenta la visita a una pantalla.
 *
 * Va en el navegador y no en el loader del servidor a propósito: en el servidor se contaría
 * también cada precarga que hace el router al pasar el mouse por un enlace, y la mitad de las
 * visitas serían de gente que nunca abrió la página.
 */
export function MedirVisita({ path }: { path: string }) {
  useEffect(() => {
    medirVisita(path);
  }, [path]);

  return null;
}
